import { useTranslation } from "@repo/core";
import type { ModalPage } from "../types";

interface ModalNavigationProps {
  currentPage: ModalPage;
  onNext?: () => void;
  onBack?: () => void;
  onClose: () => void;
  onExecute?: () => void;
  canNext?: boolean;
  canExecute?: boolean;
  isExecuting?: boolean;
}

export const ModalNavigation = ({
  currentPage,
  onNext,
  onBack,
  onClose,
  onExecute,
  canNext = false,
  canExecute = false,
  isExecuting = false,
}: ModalNavigationProps) => {
  const { tStrategy } = useTranslation();

  if (currentPage === "results") {
    return (
      <div className="flex gap-3 justify-end w-full">
        <button
          onClick={onClose}
          className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors cursor-pointer"
        >
          {tStrategy("close")}
        </button>
      </div>
    );
  }

  return (
    <div className="flex gap-3 justify-end w-full">
      {currentPage === "preview" && onExecute && (
        <button
          onClick={onExecute}
          disabled={!canExecute || isExecuting}
          className="flex items-center gap-1 px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <span className="text-sm font-medium">
            {isExecuting ? tStrategy("executing") : tStrategy("executeRebalance")}
          </span>
        </button>
      )}

      {currentPage === "overview" && onNext && (
        <button
          onClick={onNext}
          disabled={!canNext}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {tStrategy("next")}
        </button>
      )}

      {currentPage === "preview" && onBack && (
        <button
          onClick={onBack}
          className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors cursor-pointer"
        >
          {tStrategy("back")}
        </button>
      )}

      <button
        onClick={onClose}
        className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors cursor-pointer"
      >
        {tStrategy("close")}
      </button>
    </div>
  );
};
